"use client";

import Link from "next/link";
import { Logo } from "@/components/assets/icon/logo";
import { NavbarMenu } from "@/components/web/navigation/navbarMenu";
export const Navbar = () => {
  return (
    <header className="relative w-full">
      {/* Logo Section - Left - Sticky */}
      <div className="fixed top-0 left-0 z-50 flex items-center px-24 py-6">
        <Link href="/">
          {" "}
          <Logo className="hidden h-12 sm:block" />{" "}
        </Link>
      </div>

      {/* Middle Section - Not Sticky */}
      <div className="flex w-full items-center justify-center">
        {/* <span className="text-white">Middle Section</span> */}
      </div>

      {/* CTA/Navigation Section - Right - Fixed with size reduction */}
      <div className="fixed top-0 right-0 z-50 flex items-center gap-4">
        <NavbarMenu />
      </div>
    </header>
  );
};
